import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';
import GenericTable from 'componentes/generic/GenericTable.js';

const UsersTable = ({
  setIdUser,
  setOpenModal,
  users,
  setIdUserForEditPassword,
  setOpenChangePassword
}) => {
  const columns = [
    {
      accessorKey: 'usuario',
      header: 'Usuario',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'nombre',
      header: 'Nombre',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'apellidopaterno',
      header: 'Apellido Paterno',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'apellidomaterno',
      header: 'Apellido Materno',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'rol.rol',
      header: 'Rol Asignado',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'usuario',
      header: 'Usuario',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idusuario } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdUser(idusuario);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            <Button
              variant="falcon-default"
              size="sm"
              title="Cambiar Contraseña"
              onClick={() => {
                setIdUserForEditPassword(idusuario);
                setOpenChangePassword(true);
              }}
            >
              <FontAwesomeIcon icon="lock" />
            </Button>
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={users}
        title="Usuarios"
        columns={columns}
        addAction={() => {
          setIdUser(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};

UsersTable.propTypes = {
  users: PropTypes.array.isRequired,
  setIdUser: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  setIdUserForEditPassword: PropTypes.func.isRequired,
  setOpenChangePassword: PropTypes.func.isRequired
};
export default UsersTable;
